// Test IDs for reports
export const REPORTS = {
  page: 'reports-page',
  filterBar: 'reports-filter-bar',
  filterFrom: 'reports-filter-from',
  filterTo: 'reports-filter-to',
  filterSource: 'reports-filter-source',
  filterClinic: 'reports-filter-clinic',
  filterDisposition: 'reports-filter-disposition',
  resetFilters: 'reports-reset-filters',
  kpi: (name) => `reports-kpi-${name}`,
  tab: (name) => `reports-tab-${name}`,
  chart: (name) => `reports-chart-${name}`,
  table: (name) => `reports-table-${name}`,
  row: (idx) => `reports-row-${idx}`,
};
